/*  AK Custom Tabs – lightweight tab system
 *  Configure tabs in the TAB_CONFIG array below.
 *  Each entry: { id, label, sourceSelector }
 *  - id:             unique string (used for data attributes)
 *  - label:          tab button text
 *  - sourceSelector: CSS selector of the existing DOM element to relocate
 */

(function () {
  const TAB_CONFIG = [
    { id: 'about',  label: 'About Us',  sourceSelector: '.product-description' },
    { id: 'faqs',   label: 'FAQs',      sourceSelector: '.faqs' },
    // { id: 'connect', label: 'Connect', sourceSelector: '.connect-section' },
  ];

  const CONTAINER_SELECTOR = '.ak-tabs';   // wrapper you place in Liquid
  const FIRST_TAB_OPEN = true;             // auto-open first tab on load

  function init() {
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return;

    const nav = document.createElement('div');
    nav.className = 'ak-tabs__nav';

    const panels = document.createElement('div');
    panels.className = 'ak-tabs__panels';

    const activeTabs = [];

    TAB_CONFIG.forEach(function (tab) {
      const source = document.querySelector(tab.sourceSelector);
      if (!source) return; // skip if source element doesn't exist on this page

      // — Button —
      const btn = document.createElement('button');
      btn.className = 'ak-tabs__btn';
      btn.setAttribute('data-tab', tab.id);
      btn.setAttribute('aria-controls', 'ak-panel-' + tab.id);
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('role', 'tab');
      btn.textContent = tab.label;
      nav.appendChild(btn);

      // — Panel —
      const panel = document.createElement('div');
      panel.className = 'ak-tabs__panel';
      panel.id = 'ak-panel-' + tab.id;
      panel.setAttribute('role', 'tabpanel');
      panel.hidden = true;

      // Relocate the source element's contents
      panel.appendChild(source);
      source.style.display = '';          // un-hide if it was hidden
      panels.appendChild(panel);

      activeTabs.push({ btn: btn, panel: panel });
    });

    if (activeTabs.length === 0) return;  // nothing to show

    container.appendChild(nav);
    container.appendChild(panels);

    // — Click handler (event delegation) —
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('.ak-tabs__btn');
      if (!btn) return;

      activeTabs.forEach(function (t) {
        var isTarget = t.btn === btn;
        t.btn.classList.toggle('is-active', isTarget);
        t.btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        t.panel.hidden = !isTarget;
      });
    });

    // Open first tab
    if (FIRST_TAB_OPEN && activeTabs[0]) {
      activeTabs[0].btn.click();
    }
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();